/* eslint-disable react/no-danger */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable no-param-reassign */
/* eslint-disable curly */
/* eslint-disable no-undef */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable react/jsx-boolean-value */
import React, { useState, useEffect } from 'react';
import { observer } from 'mobx-react';
// import ToggleType from 'Components/common/Toggle';
import userDetail from 'Stores/userDetail';
import { makeStyles, withStyles } from '@material-ui/core/styles';
import { ReactComponent as DownArrowIcon } from 'Assets/svg/down-arrow-icon.svg';
import { ReactComponent as UserIcon } from 'Assets/svg/profileUser.svg';
import { ReactComponent as ChatIcon } from 'Assets/svg/headphones.svg';
import { ReactComponent as TickIcon } from 'Assets/svg/tick-icon.svg';
import Slider from '@material-ui/core/Slider';
import { Utils } from 'Utils/utils';
import { URLS, makeApi } from 'Utils/apiUtil';
import pricingDataState from 'Stores/pricingData';
import Button from 'Components/common/Button';
import * as CONSTANTS from 'Utils/constants';
import LoadingWrapper from 'Components/common/loadingWrapper';
import CollapsiveContent from 'Components/common/CollapsiveContent';
import ToolTip from 'Components/common/ToolTip';
import PricingUserImg from 'Assets/png/commonPricing/users.png';
import PricingProductImg from 'Assets/png/commonPricing/products.png';
import PricingCreditImg from 'Assets/png/commonPricing/credits.png';
import PricingTickImg from 'Assets/png/commonPricing/tick.png';
import PricingTogglerTickImg from 'Assets/png/commonPricing/toggler-tick.png';
import PricingCrossImg from 'Assets/png/commonPricing/cross.png';
import ChatEmailImg from 'Assets/png/commonPricing/chat-email.png';
import ChatDriftImg from 'Assets/png/commonPricing/chat-drift.png';
import G2Review1Img from 'Assets/png/commonPricing/g2Review1.png';
import G2Review2Img from 'Assets/png/commonPricing/g2Review2.png';
import { ReactComponent as InfoIcon } from 'Assets/svg/info-filled-icon.svg';
import { confirmationPopupState } from 'Components/common/confirmationPopup';
import CommonPopupWithImageComponent from 'Components/common/commonPopupWithImageComponent';
import SuccessTickBgImg from 'Assets/png/successTickBg.png';
import StripePayment from './StripePayment';

import '../../../styles/layout/_commonPricingPage.scss';

const pricingAdditionalFeatureList = {
  STARTER: [
    {
      labelText: 'Business Email Address',
      flagCheck: 'emailEnabled',
    },
    {
      labelText: 'Custom Lists',
      flagCheck: 'listBuildingEnabled',
      helpText: 'Save selected contacts into lists',
    },
    {
      labelText: 'CSV Export',
      flagCheck: 'csvExportEnabled',
    },
    {
      labelText: 'CRM Integration',
      flagCheck: 'crmExportEnabled',
    },
    {
      labelText: 'List Builder',
      flagCheck: 'leadBuilderEnabled',
    },
  ],
  BASIC: [
    {
      labelText: 'Business Email Address',
      flagCheck: 'emailEnabled',
    },
    {
      labelText: 'Custom Lists',
      flagCheck: 'listBuildingEnabled',
      helpText: 'Save selected contacts into lists',
    },
    {
      labelText: 'CSV Export',
      flagCheck: 'csvExportEnabled',
    },
    {
      labelText: 'CRM Integration',
      flagCheck: 'crmExportEnabled',
      helpText: 'Integrate your CRM to export data directly from Adapt',
      highlightText: true,
    },
    {
      labelText: 'Access to 25+ Filters',
      flagCheck: 'advancedFiltersEnabled',
      helpText: 'More options to segment your market',
      highlightText: true,
    },
    {
      labelText: 'Company Data',
      helpText:
        'Account intelligence data like revenue, location, size and more',
      highlightText: true,
    },
  ],
  GROWTH: [
    {
      labelText: 'Business Email Address',
      flagCheck: 'emailEnabled',
    },
    {
      labelText: 'Custom Lists',
      flagCheck: 'listBuildingEnabled',
      helpText: 'Save selected contacts into lists',
    },
    {
      labelText: 'CSV Export',
      flagCheck: 'csvExportEnabled',
    },
    {
      labelText: 'CRM Integration',
      flagCheck: 'crmExportEnabled',
      helpText: 'Integrate your CRM to export data directly from Adapt',
    },
    {
      labelText: 'Access to 25+ Filters',
      flagCheck: 'advancedFiltersEnabled',
      helpText: 'More options to segment your market',
    },
    {
      labelText: 'Company Data',
      helpText:
        'Account intelligence data like revenue, location, size and more',
    },
  ],
  ENTERPRISE: [
    {
      labelText: 'Business Email Address',
      flagCheck: 'emailEnabled',
    },
    {
      labelText: 'Custom Lists',
      flagCheck: 'listBuildingEnabled',
      helpText: 'Save selected contacts into lists',
    },
    {
      labelText: 'CSV Export',
      flagCheck: 'csvExportEnabled',
    },
    {
      labelText: 'CRM Integration',
      flagCheck: 'crmExportEnabled',
      helpText: 'Integrate your CRM to export data directly from Adapt',
    },
    {
      labelText: 'Access to 25+ Filters',
      flagCheck: 'advancedFiltersEnabled',
      helpText: 'More options to segment your market',
    },
    {
      labelText: 'Company Data',
      helpText:
        'Account intelligence data like revenue, location, size and more',
    },
    {
      labelText: 'Dedicated Success Manager',
      highlightText: true,
    },
    {
      labelText: 'Suppression List',
      flagCheck: 'suppressionListEnabled',
      helpText: 'Exclude contacts your own from other sources',
      highlightText: true,
    },
    {
      labelText: 'Technographic Data',
      flagCheck: 'techFilterEnabled',
      helpText: 'Search based on tech stack used by prospects',
      highlightText: true,
    },
    {
      labelText: 'API Access',
      helpText: 'Integrate Adapt for data enrichment and verification',
      highlightText: true,
    },
  ],
};

const PlanListCard = observer(props => {
  const { buyNowCbk = () => {} } = props;
  const { subscriptionPlans = [] } = userDetail;
  const { isAnnualSelected } = pricingDataState;

  let growthCredit = 1000;
  let growthSeats = 3;

  return (
    <div className="pricing-cards">
      {subscriptionPlans.map((item, index) => {
        const {
          name,
          displayName,
          price,
          annualPrice,
          numberOfSeats,
          lbCredits,
          leadBuilderEnabled,
          mostPopular,
        } = item;

        if (name === 'GROWTH') {
          growthCredit = isAnnualSelected ? lbCredits * 12 : lbCredits;
          growthSeats = numberOfSeats;
        }

        let displayCredits = isAnnualSelected ? lbCredits * 12 : lbCredits;
        let displaySeats = numberOfSeats;

        if (name === 'ENTERPRISE') {
          displayCredits = growthCredit;
          displaySeats = growthSeats;
        }

        return (
          <div className="plan-card" key={`plan-list${index}`}>
            <div className="pricing-info-section">
              {/* {mostPopular && <div className="most-popular">Most Popular</div>} */}
              {name === 'ENTERPRISE' ? (
                <>
                  <div className="plan-name">Custom</div>
                  <div className="pricing-info enterprise-pricing-info">
                    Billed Annually
                  </div>
                </>
              ) : (
                <>
                  <div className="plan-name">{displayName}</div>
                  {isAnnualSelected ? (
                    <div className="pricing-info">
                      $
                      <b>
                        {Utils.viewsDownloadsNumberFormat(annualPrice / 12)}
                      </b>{' '}
                      /month
                    </div>
                  ) : (
                    <div className="pricing-info">
                      $<b>{Utils.viewsDownloadsNumberFormat(price)}</b> /month
                    </div>
                  )}
                </>
              )}
            </div>

            <div className="credits-info-section">
              <div className="credit-info-item">
                <div className="img-icon-wrap">
                  <img src={PricingCreditImg} alt="credits" />
                </div>
                <div className="info-detail">
                  <span>{name === 'ENTERPRISE' && '>'}</span>
                  {Utils.viewsDownloadsNumberFormat(displayCredits)} Credits
                </div>
              </div>
              <div className="credit-info-item">
                <div className="img-icon-wrap">
                  <img src={PricingUserImg} alt="users" />
                </div>
                <div className="info-detail">
                  {name === 'ENTERPRISE' && <span>&gt;</span>}
                  {displaySeats} User{displaySeats > 1 && <span>s</span>}
                </div>
              </div>
              <div className="credit-info-item product-item">
                <div className="img-icon-wrap">
                  <img src={PricingProductImg} alt="product" />
                </div>
                <div
                  className="info-detail"
                  dangerouslySetInnerHTML={{
                    __html: `Chrome Extension ${
                      leadBuilderEnabled ? '& <br /> List Builder' : ''
                    }`,
                  }}
                />
              </div>
            </div>

            <div className="features-info-section">
              {pricingAdditionalFeatureList[name].map(
                (featureItem, featureIndex) => {
                  const {
                    labelText,
                    flagCheck,
                    helpText,
                    highlightText = false,
                  } = featureItem;

                  let isFeatureEnabled = true;
                  if (flagCheck !== undefined && !item[flagCheck])
                    isFeatureEnabled = false;
                  return (
                    <div
                      className={`feature-info-item${
                        highlightText ? ' highlight-text' : ''
                      }`}
                      key={`feature-item${featureIndex}`}
                    >
                      {isFeatureEnabled ? (
                        <div className="img-icon-wrap">
                          <img src={PricingTickImg} alt="tick" />
                        </div>
                      ) : (
                        <div className="img-icon-wrap">
                          <img src={PricingCrossImg} alt="cross" />
                        </div>
                      )}
                      <div className="info-detail">
                        {labelText}
                        {helpText && (
                          <div className="info-icon toolTipParentWrap">
                            <InfoIcon width={14} height={14} />
                            <ToolTip toolTipText={helpText} />
                          </div>
                        )}
                      </div>
                    </div>
                  );
                },
              )}
            </div>

            <div className="btn-section">
              <Button
                id="buyNow"
                btnText={name === 'ENTERPRISE' ? 'Talk to Us' : 'Buy Now'}
                type="button"
                className=""
                click={e => buyNowCbk(item)}
              />
            </div>
          </div>
        );
      })}
    </div>
  );
});

const ExistingPlanCard = observer(props => {
  const { featureFlags, currentSubscriptionPlanInfo = null } = userDetail;
  const { LEAD_BUILDER } = featureFlags;

  const {
    displayName,
    price,
    type,
    lbCredits,
    views,
    downloads,
    renewalDate,
    creditResetPeriod,
  } = currentSubscriptionPlanInfo;
  const renewalDateObj = new Date(renewalDate);
  return (
    <div className="pricing-section existing-plan-section">
      <div className="pricing-title">Plan and billing</div>

      <div className="plan-detail-card">
        <div className="plan-info">
          <div className="plan-heading">Current Plan</div>
          {displayName} - ${price}{' '}
          <span>{type === 0 ? ' / month' : ' / year'}</span>
        </div>
        <div className="credit-info-card">
          {Utils.isCreditBasedSubscription() ? (
            <div className="credits-detail">
              {Utils.viewsDownloadsNumberFormat(lbCredits)} credits{' '}
              {Utils.getCreditResetPeriodInString(type, creditResetPeriod)} -
              Chrome Extension <span>{LEAD_BUILDER && ' & List Builder'}</span>{' '}
              Access
            </div>
          ) : (
            <div className="credits-detail">
              {Utils.viewsDownloadsNumberFormat(views)} views and{' '}
              {Utils.viewsDownloadsNumberFormat(downloads)} downloads{' '}
              {Utils.getCreditResetPeriodInString(type, creditResetPeriod)} -
              Chrome Extension <span>{LEAD_BUILDER && ' & List Builder'}</span>{' '}
              Access
            </div>
          )}
          <div className="renewal-date">
            Next Renewal Date :{' '}
            <span>
              {renewalDateObj.toLocaleString('default', { month: 'long' })}{' '}
              {renewalDateObj.getDate()}, {renewalDateObj.getFullYear()}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
});

const ExistingPendingPlanCard = observer(props => {
  const { paymentPending } = userDetail.userInfo;
  const { isAnnual: isAnnualPlan = false, amount, planName } = paymentPending;
  return (
    <div className="pricing-section existing-plan-section existing-pending-plan-section">
      <div className="pricing-title">Plan and billing</div>

      <div className="plan-detail-card">
        <div className="plan-info">
          <div className="plan-heading">Current Plan</div>
          {planName} - ${amount}{' '}
          <span>{!isAnnualPlan ? ' / month' : ' / year'}</span>
        </div>
        <div className="credit-info-card">
          <div className="credits-detail">
            Your account is currently being setup. You will receive a
            confirmation from the Adapt team soon
          </div>
        </div>
      </div>
    </div>
  );
});

const EXISTING_PLAN_TYPES = {
  ENTERPRISE_TRIAL: 'ENTERPRISE_TRIAL',
  PAID: 'PAID',
};
const CommonPricing = observer(props => {
  const annualDiscountPercentage = 20;

  const {
    isAnnualSelected,
    showPaymentForm,
    showPaymentReviewPopup,
  } = pricingDataState;

  const {
    subscriptionPlans = [],
    isFreeTrial,
    userInfo,
    isEnterpriseFreeTrial,
    currentSubscriptionPlanInfo = null,
    hubspotCalendarLink,
  } = userDetail;

  const [existingPlanType, setExistingPlanType] = useState('');

  const openPaymentForm = selectedPlanInfo => {
    const { name, annualPrice, price } = selectedPlanInfo;
    const mxData = {
      selectedPlanType: name,
      isAnnual: isAnnualSelected,
      planAmount: isAnnualSelected ? annualPrice : price,
    };

    const {
      userStatus,
      email,
      memberSubscription,
      isEnterpriseAdmin,
      teamAdminEmail,
    } = userInfo;

    if (name === 'ENTERPRISE') {
      Utils.mixpanelTrack(
        CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_TALK_TO_US,
        mxData,
      );
      Utils.mixpanelUpdateProfileProperty({
        [CONSTANTS.MX_PROFILE_PROPERTIES.ENTERPRISE_PLAN_REQUEST]: true,
      });
      Utils.handleTrialUpgradeNow();
      Utils.hubspotEventPush(
        CONSTANTS.HUBSPOT_EVENTS.SELF_SERVE_TALK_TO_US_CLICK,
        'true',
      );
    } else if (userStatus === 0) {
      Utils.hubspotEventPush(
        CONSTANTS.HUBSPOT_EVENTS.SELF_SERVE_BUY_NOW_CLICK,
        'true',
      );
      if (memberSubscription !== null && !isEnterpriseAdmin) {
        confirmationPopupState.setPopupValues({
          content: `<br />Please contact your account administrator <a href="mailto:${teamAdminEmail}">${teamAdminEmail}</a> to upgrade your subscription.`,
          actionBtnText: 'Ok',
          needCancelBtn: false,
          showCloseBtn: false,
          callback: () => {},
        });
        confirmationPopupState.setShowPopup(true);
      } else {
        Utils.mixpanelTrack(
          CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_PLAN_SELECTED,
          mxData,
        );
        pricingDataState.setSelectedPlan(selectedPlanInfo);
        pricingDataState.setShowPaymentForm(true);
      }
    } else {
      Utils.showEmailConfirmationPopup(email);
    }
  };

  const closePaymentForm = () => {
    pricingDataState.setShowPaymentForm(false);
  };

  const enterpriseTrialChatClick = () => {
    Utils.mixpanelTrack(
      CONSTANTS.MX_PRICING_PAGE.CLICK_LB_PRICING_ENTERPRISE_TRIAL_TALK_TO_US,
      {},
    );
    window.open(hubspotCalendarLink, '_blank');
  };

  useEffect(() => {
    Utils.mixpanelTrack(CONSTANTS.MX_PRICING_PAGE.VIEW_LB_PRICING_PAGE, {});
    Utils.hubspotEventPush(
      CONSTANTS.HUBSPOT_EVENTS.SELF_SERVE_PAGE_VIEWED,
      'true',
    );
    if (isFreeTrial)
      Utils.mixpanelUpdateProfileProperty({
        [CONSTANTS.MX_PROFILE_PROPERTIES.TAM_PRICING_VIEWED]: true,
      });
  }, []);

  useEffect(() => {
    if (isFreeTrial && isEnterpriseFreeTrial)
      setExistingPlanType(EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL);
    else if (currentSubscriptionPlanInfo !== null && !isFreeTrial)
      setExistingPlanType(EXISTING_PLAN_TYPES.PAID);
    else setExistingPlanType('');
  }, [currentSubscriptionPlanInfo]);

  useEffect(() => {
    if (showPaymentForm && Utils.intlProps === null)
      Utils.initiateIntl(true, '#phoneNumber');
    else Utils.intlProps = null;
  }, [showPaymentForm]);

  const getTogglePlanType = value => {
    pricingDataState.setAnnualSelected(value);
  };

  const handleHoldSuccessOkClick = () => {
    Utils.refreshPage();
  };

  return subscriptionPlans.length === 0 ? (
    <LoadingWrapper show position="fixed" />
  ) : (
    <div className="common-pricing-component">
      {showPaymentReviewPopup && (
        <CommonPopupWithImageComponent
          ImgComponent={SuccessTickBgImg}
          titleText="Purchase Successful"
          description="Your prospecting mission is on! Our team will proceed to setup your account at the earliest and send you a confirmation. Happy Prospecting!"
          btnText="Ok"
          customParentClass="payment-hold-success-popup"
          actionBtnCallback={handleHoldSuccessOkClick}
          clickOutsidePopupCallback={handleHoldSuccessOkClick}
        />
      )}
      {Utils.isPaymentPendingReview() && <ExistingPendingPlanCard />}

      {existingPlanType === EXISTING_PLAN_TYPES.PAID &&
        !Utils.isPaymentPendingReview() && <ExistingPlanCard />}
      {existingPlanType === '' && !Utils.isPaymentPendingReview() && (
        <div className="pricing-section">
          <div className="pricing-title">
            Grow your revenue with fresh, <br /> accurate buyer intelligence
          </div>

          <div className="pricing-toggler">
            <div className="toggle-btn-section">
              <div className="toggler-group">
                <span
                  className={`toggler-left ${
                    isAnnualSelected ? '' : 'active-togger'
                  }`}
                  onClick={e => getTogglePlanType(false)}
                >
                  Monthly
                </span>
                <span className="toggler-middle">
                  <img src={PricingTogglerTickImg} alt="toggler" />
                </span>
                <span
                  className={`toggler-right ${
                    isAnnualSelected ? 'active-togger' : ''
                  }`}
                  onClick={e => getTogglePlanType(true)}
                >
                  Annual
                </span>
              </div>
            </div>
            {annualDiscountPercentage && (
              <span
                className={`offerBadge ${
                  isAnnualSelected ? 'activeToogle' : ''
                }`}
              >
                <span className="sharp-point" />
                {annualDiscountPercentage}% OFF
              </span>
            )}
          </div>

          <PlanListCard buyNowCbk={openPaymentForm} />

          {showPaymentForm && (
            <div className="payment-form-section">
              <div className="payment-section">
                <div className="animated customzoomIn">
                  <StripePayment showPaymentForm={showPaymentForm} />
                </div>
              </div>
              <div
                className="overlay-payment-form"
                onClick={closePaymentForm}
              />
            </div>
          )}
        </div>
      )}

      <div
        className={`chat-us-section ${
          existingPlanType === EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL
            ? 'chat-us-enterprise-trial'
            : ''
        }`}
      >
        <div className="chat-us-wrapper">
          <span className="chat-dot-bg" />
          <div className="chat-content">
            <div className="chat-title">
              {existingPlanType === EXISTING_PLAN_TYPES.PAID ||
              existingPlanType === EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL
                ? 'Looking to upgrade your plan?'
                : 'Looking for API / Enterprise plans?'}
            </div>
            <div className="chat-sub-title">
              or have any questions related to pricing?
            </div>
          </div>
          {existingPlanType === EXISTING_PLAN_TYPES.ENTERPRISE_TRIAL ? (
            <div className="chat-box " onClick={enterpriseTrialChatClick}>
              <img src={ChatDriftImg} alt="drift" />
              Talk to our sales representative
            </div>
          ) : (
            <>
              <div className="chat-box">
                <a
                  href={
                    existingPlanType === EXISTING_PLAN_TYPES.PAID
                      ? 'mailto:success@adapt.io'
                      : 'mailto:sales@adapt.io'
                  }
                >
                  <img src={ChatEmailImg} alt="email" />
                  <span>
                    {existingPlanType === EXISTING_PLAN_TYPES.PAID
                      ? 'success@adapt.io'
                      : 'sales@adapt.io'}
                  </span>
                </a>
              </div>
              <div className="chat-box">
                <a href="#pricingEnterpriseContact">
                  <img src={ChatDriftImg} alt="drift" />
                  Chat Now
                </a>
              </div>
            </>
          )}
        </div>
      </div>

      <div className="freqAskQuesSection">
        <h4 className="title">Frequently Asked Questions</h4>
        <div className="freqAskQuesRow">
          <div className="contentCol">
            {CONSTANTS.PRICING_FREQ_ASK_QUESTIONS.map((item, index) => {
              return (
                <CollapsiveContent
                  key={`freqAskQuestion${index + 1}`}
                  title={item.title}
                  content={item.description}
                />
              );
            })}
          </div>
        </div>
      </div>

      <div className="g2-review-section">
        <div className="g2-review-wrapper">
          <div className="left-wrapper">
            <div className="review-title">Leader in G2 Crowd</div>
            <div className="review-content">
              Our badges of honor! Adapt has been built with a customer first
              approach. Our G2 badges are a testament to that.
            </div>
            <img src={G2Review1Img} alt="g2-review1" />
          </div>
          <img className="right-wrapper" src={G2Review2Img} alt="g2-review1" />
        </div>
      </div>
    </div>
  );
});

export { CommonPricing };
export default CommonPricing;
